export interface AuthUser {
  id: number
  role: string
  language_key: string
  name: string
  last_name: string
  first_name: string
  email: string
  jwt_token: string
  jwt_token_expiry: string
  resume_token: string
  resume_token_expiry: string
  imapToken: string
  error?: string
}

export enum AuthToken {
  Refetch = 'hasura-resume-token',
  RefetchExpiry = 'hasura-resume-token-expiry'
}
